import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { Button } from '@/components/button-new'
import { WarningEnvelope, WarningIconTriangle } from '@/components/icons'
import { createModal, useModalize } from '@/components/modalize'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    max-height: 600px;
  }
`

const ImageWrapper = styled.div<{ bgColor?: string }>`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 12px;

  svg {
    height: 72px;
    width: 100%;
  }
`

const Title = styled.span`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
`

const Message = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: ${colors.grey32};
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;

  button:nth-child(2) {
    margin-left: 16px;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column-reverse;

    button:nth-child(2) {
      margin: 0 0 16px;
    }
  }
`

interface Button {
  text: string
  id?: string
  onClick?: () => void
}

interface Props {
  title: string
  message?: string | React.ReactNode
  email?: boolean
  button?: Button
  secondaryButton?: Button
  iconBgColor?: string
}

const WarningModal: React.FC<Props> = ({
  title,
  message,
  email,
  button = null,
  secondaryButton = null
}) => {
  const { close } = useModalize()

  return (
    <Wrapper>
      <ImageWrapper>
        {email ? (
          <WarningEnvelope width={44} />
        ) : (
          <WarningIconTriangle width={44} />
        )}
      </ImageWrapper>
      <ContentWrapper>
        <Title>{title}</Title>
        {message && <Message>{message}</Message>}
      </ContentWrapper>
      <ButtonsWrapper>
        {secondaryButton && (
          <Button
            theme="secondary"
            width="100%"
            onClick={() => {
              close()
              secondaryButton.onClick && secondaryButton.onClick()
            }}
            id={secondaryButton.id || ''}
          >
            {secondaryButton.text}
          </Button>
        )}
        {button && (
          <Button
            theme="primary"
            width="100%"
            onClick={() => {
              close()
              button.onClick && button.onClick()
            }}
            id={button.id || ''}
          >
            {button.text}
          </Button>
        )}
      </ButtonsWrapper>
    </Wrapper>
  )
}

export const showWarningModal = createModal(WarningModal, {
  showClose: false,
  width: '100%',
  maxWidth: '460px',
  clickOutside: false
})

export const showWarningModalWithCloseButton = createModal(WarningModal, {
  showClose: true
})
